import eventPassive from './event-passive';

const swipeEvents = {
  install(Vue) {
    function touchStartEvent(event) {
      const $this = this.$$touchObj;

      if ($this.touchStarted) {
        return;
      }

      $this.touchStarted = true;

      $this.startX = event.changedTouches[0].screenX;
      $this.startY = event.changedTouches[0].screenY;

      $this.currentX = 0;
      $this.currentY = 0;

      $this.touchStartTime = event.timeStamp;
    }

    function touchEndEvent(event) {
      const $this = this.$$touchObj;

      $this.currentX = event.changedTouches[0].screenX;
      $this.currentY = event.changedTouches[0].screenY;

      const distanceY = Math.abs($this.startY - $this.currentY);
      const distanceX = Math.abs($this.startX - $this.currentX);

      if (distanceX > $this.options.swipeTolerance && distanceY < distanceX) {
        const direction = $this.startX > $this.currentX ? 'left' : 'right';

        const binding = $this.callbacks[`swipe.${direction}`];

        if (binding) {
          binding.value();
        }
      } else if (distanceY > $this.options.swipeTolerance && distanceX < distanceY) {
        const direction = $this.startY > $this.currentY ? 'up' : 'down';

        const binding = $this.callbacks[`swipe.${direction}`];

        if (binding) {
          binding.value();
        }
      }

      $this.touchStarted = false;
    }

    function buildTouchObj($el) {
      const touchObj = $el.$$touchObj || {
        callbacks: {},
        // prevent bind twice, set to true when event bound
        hasBindTouchEvents: false,
        options: { swipeTolerance: 30 },
      };

      // eslint-disable-next-line no-param-reassign
      $el.$$touchObj = touchObj;
      return $el.$$touchObj;
    }

    Vue.directive('swipe', {
      bind: ($el, binding) => {
        const $this = buildTouchObj($el);

        const m = binding.modifiers;
        if (m.left || m.right || m.up || m.down) {
          // eslint-disable-next-line no-restricted-syntax
          for (const i in binding.modifiers) {
            if (['left', 'right', 'up', 'down'].indexOf(i) >= 0) {
              const e = `swipe.${i}`;
              if (!$this.callbacks[e]) {
                $this.callbacks[e] = binding;
              }
            }
          }
        }

        // prevent bind twice
        if ($this.hasBindTouchEvents) {
          return;
        }

        $el.addEventListener('touchstart', touchStartEvent, eventPassive());
        $el.addEventListener('touchend', touchEndEvent, eventPassive());

        $this.hasBindTouchEvents = true;
      },
      unbind: ($el) => {
        $el.removeEventListener('touchstart', touchStartEvent);
        $el.removeEventListener('touchend', touchEndEvent);
      },
    });
  },
};

export default swipeEvents;
